import { motion } from "motion/react";
import StarMini from "../ui/StarMini/StarMini";

const DecorativeStars = () => (
  <>
    <motion.div
      animate={{
        opacity: "100%",
        x: 100,
      }}
      initial={{
        opacity: "0",
        x: 100,
      }}
      transition={{ duration: 8, repeat: Infinity, repeatType: "reverse" }}
    >
      <StarMini className="fill-bright-future-base" />
    </motion.div>
    <motion.div
      animate={{ opacity: "100%" }}
      initial={{ opacity: "0" }}
      transition={{ duration: 12, repeat: Infinity, repeatType: "reverse" }}
    >
      <StarMini className="fill-bright-future-base" />
    </motion.div>
    <motion.div
      animate={{
        opacity: "100%",
        y: -170,
      }}
      initial={{
        opacity: "0",
        y: -170,
      }}
      transition={{ duration: 6, repeat: Infinity, repeatType: "reverse" }}
    >
      <StarMini className="fill-bright-future-base" />
    </motion.div>
  </>
);

export default DecorativeStars;
